module.exports = __webpack_public_path__ + "static/assets/955fc0224762c96ebcc86065fa9f14f0.gif";